import React from "react";
import { Button } from "../../../../../design/button";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Professional } from "../../../../../models/Professional";
import {
  DescriptionDetails,
  DescriptionList,
  DescriptionTerm,
} from "../../../../../design/description-list";
import ProfessionalRoleBadge from "../../../../../components/ProfessionalRoleBadge";
import { Text } from "../../../../../design/text";

const OnboardingReviewAndSubscribeStep: React.FC<{
  formData: Partial<Professional>;
  onBack: () => void;
  onSubscribe: () => void;
  isLoading: boolean;
}> = ({ formData, onBack, onSubscribe, isLoading }) => {
  return (
    <OnboardingContainer title="Review and Subscribe">
      <>
        <Text>
          Please review your information before subscribing to publish your
          profile.
        </Text>

        <DescriptionList>
          <DescriptionTerm>Name</DescriptionTerm>
          <DescriptionDetails>
            {formData.firstName} {formData.lastName}
          </DescriptionDetails>
          <DescriptionTerm>Email</DescriptionTerm>
          <DescriptionDetails>{formData.email}</DescriptionDetails>
          <DescriptionTerm>Phone</DescriptionTerm>
          <DescriptionDetails>{formData.phoneNumber}</DescriptionDetails>
          <DescriptionTerm>Organization</DescriptionTerm>
          <DescriptionDetails>{formData.organization}</DescriptionDetails>
          <DescriptionTerm>Roles</DescriptionTerm>
          <DescriptionDetails>
            {formData.roles?.map((role) => (
              <ProfessionalRoleBadge key={role} role={role} />
            ))}
          </DescriptionDetails>
          <DescriptionTerm>Languages</DescriptionTerm>
          <DescriptionDetails>
            {formData.languagesSpoken?.join(", ")}
          </DescriptionDetails>
          <DescriptionTerm>Location</DescriptionTerm>
          <DescriptionDetails>
            {formData.city}, {formData.state}
          </DescriptionDetails>
          <DescriptionTerm>Bio</DescriptionTerm>
          <DescriptionDetails className="whitespace-pre-line">
            {formData.bio}
          </DescriptionDetails>
          <DescriptionTerm>Website URL</DescriptionTerm>
          <DescriptionDetails>{formData.websiteUrl}</DescriptionDetails>
          <DescriptionTerm>Scheduling URL</DescriptionTerm>
          <DescriptionDetails>{formData.schedulingUrl}</DescriptionDetails>
        </DescriptionList>

        <div className="flex justify-between gap-4 mt-8">
          <Button type="button" onClick={onBack} disabled={isLoading}>
            Back
          </Button>
          <Button onClick={onSubscribe} className="w-full" disabled={isLoading}>
            {isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingReviewAndSubscribeStep;
